import { memo, useMemo, useState } from 'react';
import { Collapse, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DISPATCH_BTN_ENUM } from 'components/Order/OrderDeliverDetails/hooks/useDeliveryDispatchDetails';
import {
  StyledShowMoreLessButton,
  StyledShowMoreLessLink,
  StyledShowMoreLessText,
} from 'components/Order/OrderStatusChange/styles';

const ProviderDeliveryDetails = ({ deliveryData, providers }) => {
  const { t } = useTranslation();
  const [showDetails, setShowDetails] = useState(false);
  const handleClick = () => setShowDetails((prevState) => !prevState);

  console.log('deliveryData', deliveryData);

  const url = useMemo(() => {
    if (!deliveryData) return '';

    const baseUrl = `${process.env.REACT_APP_TRACK_URL}/?oUuid=${deliveryData?.uuid}&bid=${deliveryData?.business[0]?._id}&bUuid=${deliveryData?.business[0]?.uuid}`;

    const shouldIncludeOcoId =
      deliveryData?.oco_external_id && deliveryData?.provider === 'ubereats';

    return shouldIncludeOcoId
      ? `${baseUrl}&oco_external_id=${deliveryData?.oco_external_id}`
      : baseUrl;
  }, [
    deliveryData,
    deliveryData?.uuid,
    deliveryData?.business,
    deliveryData?.oco_external_id,
  ]);

  return (
    <>
      <Collapse in={showDetails}>
        <Box>
          <StyledShowMoreLessText>
            {t('Delivered by')}{' '}
            {deliveryData.delivery?.deliveryCarrier === 'self' ? (
              t('website_settings.in_house_delivery').toUpperCase()
            ) : (
              <>
                {deliveryData?.provider?.toUpperCase() === providers.food2.srv
                  ? deliveryData?.provider?.toUpperCase()
                  : deliveryData?.delivery?.deliveryCarrier?.toUpperCase()}
              </>
            )}
          </StyledShowMoreLessText>
          <StyledShowMoreLessText>
            {t('Phone Number:')}{' '}
            {deliveryData?.phoneNumber || deliveryData?.phone || '-'}
          </StyledShowMoreLessText>
          <Box sx={{ display: 'flex', gap: '5px' }}>
            <StyledShowMoreLessText>
              {t('Tracking URL:')}
            </StyledShowMoreLessText>
            <StyledShowMoreLessLink href={url} target={'_blank'}>
              Link
            </StyledShowMoreLessLink>
          </Box>
          <StyledShowMoreLessText>
            {t('Ref. Code')}: {deliveryData?.referenceCode || '-'}
          </StyledShowMoreLessText>
        </Box>
      </Collapse>
      <StyledShowMoreLessButton
        sx={{ mt: showDetails ? 2 : 0 }}
        variant="outlined"
        onClick={handleClick}
      >
        {showDetails
          ? DISPATCH_BTN_ENUM.SHOW_LESS
          : DISPATCH_BTN_ENUM.SHOW_MORE}
      </StyledShowMoreLessButton>
    </>
  );
};

export default memo(ProviderDeliveryDetails);
